import React, { Component } from 'react';

const tools = [
  {
    icon: '💰',
    title: 'กำหนดวงเงินฝาก',
    desc: 'ตั้งวงเงินฝากรายวัน รายสัปดาห์ หรือรายเดือน เพื่อควบคุมการใช้จ่ายของคุณ',
  },
  {
    icon: '⏱️',
    title: 'กำหนดเวลาเล่น',
    desc: 'กำหนดเวลาเล่นสูงสุดต่อวัน ระบบจะแจ้งเตือนเมื่อถึงเวลาที่ตั้งไว้',
  },
  {
    icon: '🚫',
    title: 'ระงับบัญชีชั่วคราว',
    desc: 'พักการเล่นชั่วคราว 24 ชั่วโมง, 7 วัน, 1 เดือน หรือ 6 เดือน',
  },
  {
    icon: '🔒',
    title: 'ปิดบัญชีถาวร',
    desc: 'หากต้องการหยุดเล่นอย่างถาวร เราสามารถปิดบัญชีของคุณได้ทันที',
  },
  {
    icon: '📊',
    title: 'ตรวจสอบประวัติ',
    desc: 'ดูประวัติการเดิมพัน การฝาก–ถอน และติดตามพฤติกรรมการเล่นของคุณ',
  },
  {
    icon: '🧠',
    title: 'แบบทดสอบตัวเอง',
    desc: 'ทำแบบทดสอบเพื่อประเมินว่าคุณมีความเสี่ยงต่อการติดการพนันหรือไม่',
  },
];

const signs = [
  'เล่นพนันมากกว่าที่ตั้งใจไว้',
  'ใช้เวลากับการพนันมากขึ้นเรื่อย ๆ',
  'รู้สึกกระวนกระวายเมื่อไม่ได้เล่น',
  'พยายามเล่นเพื่อชดเชยเงินที่เสียไป',
  'โกหกครอบครัวหรือเพื่อนเกี่ยวกับการพนัน',
  'กู้ยืมเงินหรือขายทรัพย์สินเพื่อนำมาพนัน',
  'ละเลยหน้าที่การงานหรือครอบครัวเพราะการพนัน',
  'รู้สึกผิดหลังการเล่นพนัน',
];

const faqs = [
  {
    q: 'ฉันจะรู้ได้อย่างไรว่าติดการพนัน?',
    a: 'หากคุณพบว่าตัวเองเล่นพนันมากกว่าที่ตั้งใจ ยืมเงินเพื่อพนัน หรือรู้สึกไม่สบายใจเมื่อไม่ได้เล่น อาจเป็นสัญญาณว่าคุณต้องการความช่วยเหลือ',
  },
  {
    q: 'จะขอความช่วยเหลือได้ที่ไหน?',
    a: 'ติดต่อสายด่วนสุขภาพจิต 1323 (กรมสุขภาพจิต ประเทศไทย) หรือปรึกษาผู้เชี่ยวชาญด้านสุขภาพจิตใกล้บ้านคุณ',
  },
  {
    q: 'PK8ปกป้องผู้เล่นอย่างไร?',
    a: 'PK8มีเครื่องมือช่วยให้ผู้เล่นควบคุมการเล่นด้วยตนเอง เช่น กำหนดวงเงิน ระงับบัญชีชั่วคราว และทีมสนับสนุนตลอด 24 ชั่วโมง',
  },
  {
    q: 'เด็กสามารถเล่นได้หรือไม่?',
    a: 'ไม่ได้ PK8อนุญาตเฉพาะผู้ที่มีอายุ 18 ปีบริบูรณ์ขึ้นไปเท่านั้น และมีระบบยืนยันอายุเพื่อป้องกันผู้เยาว์',
  },
];

class ResponsiblePage extends Component {
  constructor(props) {
    super(props);
    this.state = { openFaq: null };
  }

  toggleFaq(idx) {
    this.setState(prev => ({ openFaq: prev.openFaq === idx ? null : idx }));
  }

  render() {
    const { openFaq } = this.state;

    return (
      <div style={{ background: '#0a1628', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif', color: '#fff' }}>

        {/* ── Hero ── */}
        <div style={{
          background: 'linear-gradient(135deg, #051030 0%, #0d2348 60%, #1a3a6e 100%)',
          padding: '56px 24px 40px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 12, color: '#f5a623', letterSpacing: 3, marginBottom: 8, textTransform: 'uppercase' }}>Responsible Gaming</div>
          <h1 style={{ fontSize: 26, fontWeight: 800, margin: '0 0 12px' }}>เล่นเกมอย่างมีความรับผิดชอบ</h1>
          <p style={{ fontSize: 13, color: '#8aaccc', maxWidth: 500, margin: '0 auto' }}>
            PK8ใส่ใจความปลอดภัยและสุขภาวะของผู้เล่นทุกท่าน
            เราส่งเสริมการเล่นเพื่อความบันเทิงในขอบเขตที่เหมาะสม
          </p>
        </div>

        {/* ── Intro Card ── */}
        <div style={{ maxWidth: 760, margin: '32px auto 0', padding: '0 20px' }}>
          <div style={{ background: '#0d2040', borderRadius: 12, padding: '24px', border: '1px solid #1e3560', display: 'flex', gap: 16, alignItems: 'flex-start' }}>
            <div style={{ fontSize: 36, flexShrink: 0 }}>🎮</div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#f5a623', marginBottom: 8 }}>การพนันควรเป็นความบันเทิง ไม่ใช่ภาระ</div>
              <p style={{ fontSize: 13, color: '#8aaccc', lineHeight: 1.9, margin: 0 }}>
                PK8เชื่อว่าการเดิมพันที่ดีต้องอยู่บนพื้นฐานของความสนุกสนานและความรับผิดชอบ
                เราสนับสนุนให้ผู้เล่นตั้งงบประมาณ กำหนดเวลา และรู้จักหยุดเมื่อถึงเวลา
              </p>
            </div>
          </div>
        </div>

        {/* ── Tools ── */}
        <div style={{ maxWidth: 760, margin: '32px auto 0', padding: '0 20px' }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: '#c8d6e5', marginBottom: 16 }}>เครื่องมือควบคุมตัวเอง</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
            {tools.map((tool, i) => (
              <div key={i} style={{ background: '#0d1f3c', borderRadius: 10, padding: '18px 16px', border: '1px solid #1e3560' }}>
                <div style={{ fontSize: 28, marginBottom: 10 }}>{tool.icon}</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#e8f0fe', marginBottom: 6 }}>{tool.title}</div>
                <div style={{ fontSize: 12, color: '#8aaccc', lineHeight: 1.8 }}>{tool.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Warning Signs ── */}
        <div style={{ maxWidth: 760, margin: '32px auto 0', padding: '0 20px' }}>
          <div style={{ background: 'rgba(230, 80, 60, 0.08)', borderRadius: 12, padding: '24px', border: '1px solid rgba(230, 80, 60, 0.3)' }}>
            <h2 style={{ fontSize: 15, fontWeight: 700, color: '#ff6b5b', marginBottom: 14 }}>⚠️ สัญญาณเตือนของการติดการพนัน</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              {signs.map((sign, i) => (
                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: '#c8d6e5', lineHeight: 1.7 }}>
                  <span style={{ color: '#ff6b5b', flexShrink: 0, marginTop: 2 }}>•</span>
                  {sign}
                </div>
              ))}
            </div>
            <p style={{ fontSize: 12, color: '#8aaccc', marginTop: 14, marginBottom: 0, lineHeight: 1.8 }}>
              หากคุณพบว่าตัวเองมีพฤติกรรมเหล่านี้ โปรดติดต่อขอความช่วยเหลือได้ทันที
            </p>
          </div>
        </div>

        {/* ── Helpline ── */}
        <div style={{ maxWidth: 760, margin: '24px auto 0', padding: '0 20px' }}>
          <div style={{ background: 'linear-gradient(135deg, #0e2a50, #0d2040)', borderRadius: 12, padding: '24px', border: '1px solid #1e3560', display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
            <div style={{ fontSize: 40 }}>📞</div>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#f5a623', marginBottom: 6 }}>สายด่วนให้คำปรึกษา</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 4 }}>1323</div>
              <div style={{ fontSize: 12, color: '#8aaccc' }}>กรมสุขภาพจิต ประเทศไทย — บริการฟรีตลอด 24 ชั่วโมง</div>
            </div>
            <div style={{ textAlign: 'center', minWidth: 120 }}>
              <div style={{ fontSize: 13, color: '#8aaccc', marginBottom: 8 }}>หรือติดต่อทีมเรา</div>
              <div style={{ background: '#f5a623', color: '#0a1628', borderRadius: 8, padding: '8px 20px', fontWeight: 700, fontSize: 13 }}>
                แชทสด 24/7
              </div>
            </div>
          </div>
        </div>

        {/* ── FAQ ── */}
        <div style={{ maxWidth: 760, margin: '32px auto 48px', padding: '0 20px' }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: '#c8d6e5', marginBottom: 16 }}>คำถามที่พบบ่อย</h2>
          {faqs.map((faq, idx) => {
            const isOpen = openFaq === idx;
            return (
              <div key={idx} style={{ marginBottom: 8, borderRadius: 10, overflow: 'hidden', border: '1px solid #1e3560' }}>
                <button
                  onClick={() => this.toggleFaq(idx)}
                  style={{
                    width: '100%', textAlign: 'left', background: isOpen ? '#0e2a50' : '#0d1f3c',
                    border: 'none', cursor: 'pointer', padding: '14px 18px',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    color: isOpen ? '#f5a623' : '#c8d6e5', fontFamily: 'inherit',
                    fontWeight: 600, fontSize: 13, transition: 'background .2s',
                  }}
                >
                  <span>{faq.q}</span>
                  <span style={{ fontSize: 18, color: '#f5a623' }}>{isOpen ? '−' : '+'}</span>
                </button>
                {isOpen && (
                  <div style={{ background: '#081524', padding: '14px 18px', fontSize: 13, color: '#8aaccc', lineHeight: 1.9 }}>
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ── Age Restriction ── */}
        <div style={{ maxWidth: 760, margin: '0 auto 40px', padding: '0 20px' }}>
          <div style={{ background: '#0d1f3c', borderRadius: 10, padding: '16px 20px', border: '1px solid #1e3560', display: 'flex', gap: 12, alignItems: 'center', fontSize: 13, color: '#8aaccc' }}>
            <div style={{ fontSize: 32, flexShrink: 0 }}>🔞</div>
            <div style={{ lineHeight: 1.8 }}>
              <strong style={{ color: '#c8d6e5' }}>บริการของ PK8สำหรับผู้ที่มีอายุ 18 ปีขึ้นไปเท่านั้น</strong><br />
              หากคุณทราบว่ามีผู้เยาว์กำลังเข้าถึงบริการของเรา โปรดแจ้งทีมสนับสนุนทันที
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default ResponsiblePage;
